import React, { useEffect, useState } from 'react'
import { TiUserAddOutline } from "react-icons/ti";
import { BsArrowUpRightSquare } from "react-icons/bs";
import { IoWallet } from "react-icons/io5";
import { IoMdEye } from "react-icons/io";
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { setClickUserId, setClickUserState } from '../Store/UserSlice';
import { FaArrowDown, FaArrowUp, FaLocationArrow } from 'react-icons/fa';
import { TfiTime } from 'react-icons/tfi';

const RecentPlatfrom = () => {
const ApiUrl=process.env.REACT_APP_API;
const dispatch=useDispatch()

const UserActivitFull=useSelector(state=>state.user.UserActivityData)
const UserActivit=UserActivitFull.newActivity
console.log("UserActivit",UserActivit)

const [rowsToShow, setRowsToShow] = useState(6); 
const handleShowMore = () => {
  setRowsToShow(prevRowsToShow => prevRowsToShow + 6);
};

const handleShowLess = () => {
  setRowsToShow(prevRowsToShow => (prevRowsToShow > 6 ? prevRowsToShow - 6 : 6)); 
};



const getActivityTime = (timestamp) => {
    const now = new Date();
    const activityTime = new Date(timestamp * 1000); 
    const diff = Math.abs(now - activityTime);
  
    const hours = Math.floor(diff / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
  
    if (hours >= 24) {
        const totalDays = Math.floor(hours / 24);
        const remainingHours = hours % 24;
        return `${totalDays} Day`;
      }
      if (hours > 0) {
        return `${hours} Hour`;
      }
      if (minutes > 0) {
        return `${minutes} Minute${minutes > 1 ? 's' : ''}`;
      }
      
  };
  

    const userItems = UserActivit ? UserActivit.map(activity => {
      const timestamp = activity?.time;
      
      return {
        userIcon: <TiUserAddOutline size={35} className='p-2 bg-[#444] rounded-full' />,
        user: activity?.activity,
        userId: `${activity?.userId}`,
        usedPrice: activity?.amount,
        arroIcons:<TfiTime />,
        userTime: getActivityTime(timestamp),
      };
    }) : [];


      const ClickOnId=(id)=>{
        dispatch(setClickUserState(true))
dispatch(setClickUserId(id))
      }


    return (
        <>
        <div className='Recenet_plateform '>
            <div className=' RecentPlateform_HsowMore'>
                {
                    userItems?.slice(0,rowsToShow).map((item, index) => (
                        <div key={index}>
                            <div className='flex   md:flex-row justify-between imx text-white RecenT_table_border '>
                                <div className='flex items-center md:gap-5 gap-2 py-3'>
                                    <p className='text-sm md:text-base'>{item.userIcon}</p>
                                    <p className='text-sm md:text-base'>{item.user}</p>
                                    <button className='py-2 md:px-6 px-3 rounded-[10px] text-white bg-[#444] hover:bg-[#555] text-xs md:text-base Main_GradienTCoilor' onClick={()=>ClickOnId(item.userId)}>ID {item.userId}</button>
                                    <p className='md:font-bold text-xs md:text-base'>{item.usedPrice} <span className='text-purple-500'>{item.subText}</span></p>
                                </div>
                                <div className='flex justify-center items-center text-sm md:text-base text-white gap-4'>
                                    <p>{item.userTime}</p>
                                    <p>{item.arroIcons}</p>
                                </div>
                            </div>
                            {/* <hr className='border-1 py-2 border-gray-600 w-full' /> */}
                        </div>
                    ))
                }
            </div>
                <div className='flex justify-between p-3 items-center  text-white'>
                    {/* <button className='py-3 hover:bg-[#555] px-28 md:px-[35%] lg:px-[37%] flex  mx-auto items-center bg-[#444] rounded-xl w-full  gap-3 text-white font-medium'><span >
                        <IoMdEye size={20} /></span>
                    <span >See more</span></button> */}
                    <p onClick={handleShowLess} className='flex justify-center items-center Main_GradienTCoilor gap-3 rounded-lg px-2 py-2 '><FaArrowUp /> <span>Show Less</span></p>
                       
                        <p onClick={handleShowMore} className='flex justify-center items-center Main_GradienTCoilor gap-3 rounded-lg px-2 py-2'><FaArrowDown /> <span>Show more</span></p>
                </div>

            </div>
        </>
    )
}

export default RecentPlatfrom



